module.exports = __webpack_public_path__ + "img/Xionglei_Beijing.1331e300.png";